import React from "react";
import ModalShell from "./ModalShell";

const ReconciliationDetailModal = ({ item, onClose, formatIDR, formatDateTime }) => (
  <ModalShell eyebrow="DETAIL OPNAME" title={item.reconciliation_no || "Opname Kas & Bank"} subtitle={`${item.account_name || "Akun"} · ${formatDateTime(item.occurred_at)}`} onClose={onClose}>
    <div className="cash-bank-opname-detail">
      <div><small>Saldo sistem</small><strong>{formatIDR(item.expected_balance)}</strong></div>
      <div><small>Saldo aktual</small><strong>{formatIDR(item.actual_balance)}</strong></div>
      <div className={Number(item.difference) === 0 ? "is-match" : Number(item.difference) > 0 ? "is-surplus" : "is-shortage"}><small>Selisih</small><strong>{Number(item.difference) > 0 ? "+" : ""}{formatIDR(item.difference)}</strong></div>
    </div>
    <div className="cash-bank-audit-copy"><div><span>Alasan</span><strong>{item.reason || "Saldo sudah sesuai"}</strong></div><div><span>Catatan</span><strong>{item.note || "-"}</strong></div><div><span>Diproses oleh</span><strong>{item.created_by_name || "Sistem"}</strong></div></div>
  </ModalShell>
);

export default ReconciliationDetailModal;
